export type ThemeConfig = {
    colors: {
      primary: {
        light: string;
        main: string;
        dark: string;
        text: string;
        surface: string;
        hover: string;
        inverse: {
          background: string;
          text: string;
          border: string;
          icon: string;
        };
      };
      secondary: {
        light: string;
        main: string;
        dark: string;
        text: string;
        surface: string;
        hover: string;
        inverse: {
          background: string;
          text: string;
          border: string;
          icon: string;
        };
      };
      text: {
        primary: string;
        secondary: string;
        light: string;
        hover: string;
      };
      background: {
        main: string;
        light: string;
        dark: string;
        surface: string;
        hover: string;
        // REMOVED: gradient (moved to gradients.page.main)
      };
      border: {
        light: string;
        main: string;
        dark: string;
        hover: string;
      };
      success: {
        light: string;
        main: string;
        dark: string;
        text: string;
        surface: string;
        hover: string;
      };
    };
    gradients: {
      hero: string;
      card: string;
      // RENAMED: section -> page
      page: {
        // RENAMED: section -> main
        main: string;
        divider: {
          light: string;
          dark: string;
        };
      };
    };
    overlays: {
      dotMatrix: string;
      pattern: string;
      grid: string;
      noise: string;
    };
    dividers: {
      section: string;
      card: string;
      content: string;
    };
    spacing: {
      section: {
        sm: string;
        md: string;
        lg: string;
      };
      container: {
        sm: string;
        md: string;
        lg: string;
      };
    };
  };
  
  export const defaultTheme: ThemeConfig = {
    colors: {
      primary: {
        light: 'text-violet-300',
        main: 'text-violet-600',
        dark: 'text-violet-800',
        text: 'text-slate-900',
        surface: 'bg-violet-50',
        hover: 'hover:bg-violet-100',
        inverse: {
            background: 'group-hover:bg-violet-50',
            text: 'group-hover:text-violet-900',
            border: 'group-hover:border-violet-200',
            icon: 'group-hover:text-violet-600'
          }
      },
      secondary: {
        light: 'text-indigo-300',
        main: 'text-indigo-600',
        dark: 'text-indigo-800',
        text: 'text-slate-900',
        surface: 'bg-indigo-50',
        hover: 'hover:bg-indigo-100',
        inverse: {
            background: 'group-hover:bg-indigo-50',
            text: 'group-hover:text-indigo-900',
            border: 'group-hover:border-indigo-200',
            icon: 'group-hover:text-indigo-600'
          }
      },
      text: {
        primary: 'text-slate-900',
        secondary: 'text-slate-600',
        light: 'text-white',
        hover: 'hover:text-slate-700'
      },
      background: {
        main: 'bg-white',
        light: 'bg-slate-50',
        dark: 'bg-slate-900',
        surface: 'bg-white',
        hover: 'hover:bg-slate-100'
      },
      border: {  // Added border colors
        light: 'border-slate-200',
        main: 'border-slate-300',
        dark: 'border-slate-400',
        hover: 'hover:border-violet-300'
      },
      success: {
        light: 'text-violet-200',
        main: 'text-violet-500',
        dark: 'text-violet-700',
        text: 'text-violet-600',
        surface: 'bg-violet-50/50',
        hover: 'hover:bg-violet-100/50'
      }
    },
    gradients: {
      hero: 'bg-gradient-to-br from-indigo-600 via-indigo-700 to-violet-800',
      card: 'bg-gradient-to-r from-violet-500 to-indigo-500',
      page: {
        main: 'bg-gradient-to-b from-slate-50 to-white',
        divider: {
            light: 'bg-gradient-to-b from-white to-slate-50',
            dark: 'bg-gradient-to-b from-slate-50 to-white'
        }
      },      
    },
    overlays: {
        dotMatrix: "bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMSIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==')]",
        pattern: 'bg-[linear-gradient(45deg,transparent_25%,rgba(0,0,0,0.02)_25%,rgba(0,0,0,0.02)_50%,transparent_50%,transparent_75%,rgba(0,0,0,0.02)_75%)] bg-[length:24px_24px]',
        grid: 'bg-slate-900 bg-[linear-gradient(to_right,rgb(243,244,246)_1px,transparent_1px),linear-gradient(to_bottom,rgb(243,244,246)_1px,transparent_1px)] bg-[size:24px_24px]',
        noise: 'bg-[url(data:image/png;base64,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)]'
      },
      dividers: {
        section: 'h-16 overflow-hidden',
        card: 'border-t border-slate-200',
        content: 'border-b border-slate-200'
      },
      spacing: {
        section: {
          sm: 'py-8 md:py-12',
          md: 'py-12 md:py-16',
          lg: 'py-16 md:py-24'
        },
        container: {
          sm: 'p-4',
          md: 'p-6 sm:p-6',
          lg: 'p-8 sm:p-6 lg:p-8'
        }
      }
  };
  
  // Helper function to get theme class
  type ThemeClassType = 'default' | 'text' | 'hover' | 'borderHover' | 'inverse';

  export const getThemeClass = (
    path: string,
    type: ThemeClassType = 'default',
    theme: ThemeConfig = defaultTheme
  ): string => {
    const pathParts = path.split('.');
    let current: any = theme;
  
    for (const part of pathParts) {
      if (!current[part]) {
        console.warn(`Theme path ${path} not found`);
        return '';
      }
      current = current[part];
    }
  
    switch (type) {
      case 'text':
        return current;
      case 'hover':
        return current.hover || `hover:${current}`;
      case 'borderHover':
        return `hover:border-${current}/50`;
      default:
        return current;
    }
  };
  
  // Example usage:
  // getThemeClass('colors.primary.main') => 'indigo-600'
  // getThemeClass('gradients.hero') => 'bg-gradient-to-br from-indigo-600 via-indigo-700 to-violet-800'
  // getThemeClass('colors.success.main', 'text') => 'text-emerald-500'